/**
 * ✅ EmployeeTable Component
 * Re-exports the integrated employee table component
 */
import EmployeeTableIntegrated from "./EmployeeTableIntegrated";

export default EmployeeTableIntegrated;
